module.exports = __webpack_public_path__ + "img/level_four_lock.8491bfd0.png";